import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import PhproductstatusFilterCriteria from './PhproductstatusFilterCriteria'
import PhproductstatusList from './PhproductstatusList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './PhproductstatusAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setPhproductstatusDashboardPhproductstatusList } from '../../store/slice/PharmaSlice';

export default function PhproductstatusListView({setShowEdit,setPhproductstatusId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.phproductstatusDashboard);   

    const [filteredPhproductstatusList, setFilteredPhproductstatusList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { phproductstatusDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (phproductstatusDashboard.phproductstatusList.length>-1){
        setFilteredPhproductstatusList(phproductstatusDashboard.phproductstatusList);
        transformToCardFormat(phproductstatusDashboard.phproductstatusList, setCardList);
      }
    },[phproductstatusDashboard.phproductstatusList])

    useEffect(()=>{
          transformToCardFormat(filteredPhproductstatusList, setCardList);
      },[filteredPhproductstatusList])

    useEffect(()=>{
        if (filterCriteria.title==='' ){
            setFilteredPhproductstatusList(phproductstatusDashboard.phproductstatusList);
            transformToCardFormat(phproductstatusDashboard.phproductstatusList, setCardList);

        } else {
            setFilteredPhproductstatusList(
                phproductstatusDashboard.phproductstatusList
                    .filter(phproductstatus=> phproductstatus.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(phproductstatusDashboard.filteredPhproductstatusList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <PhproductstatusList
                    setShowEdit={setShowEdit}
                    setPhproductstatusId = {setPhproductstatusId}
                    tableList={filteredPhproductstatusList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}